import PostcodeValidator from './postcode_validator';

export const showAutoCompletePostcodeSelector = store => ['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].includes(store);

export const postcodeSelectRegex = /^([0-9]{4}),([A-Za-z-]+)\w+$/;

export const validatePostcode = (store, postcode, suggestion, touched) => {
    let isValid = false;
    if (!postcode) return false;
    if (showAutoCompletePostcodeSelector(store)) {
        isValid = touched ? postcodeSelectRegex.test(postcode.replace(/\s+/g, '')) && suggestion : postcodeSelectRegex.test(postcode.replace(/\s+/g, ''));
    } else {
        isValid = PostcodeValidator.validate(postcode);
    }
    return isValid;
}